var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUpLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "10 10 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.2169 14.2937L17.2715 18.1997V27.1997H25.4533L28.1806 20.8997V19.0997H20.2078L21.2169 14.2937Z",
    fill: "#89C925"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1804 17.3H22.444L23.3077 13.187L23.3349 12.899C23.3349 12.53 23.1804 12.188 22.9349 11.945L21.9713 11L15.9895 16.931C15.6531 17.255 15.4531 17.705 15.4531 18.2V27.2C15.4531 28.19 16.2713 29 17.2713 29H25.4531C26.2077 29 26.8531 28.55 27.1259 27.902L29.8713 21.557C29.9531 21.35 29.9986 21.134 29.9986 20.9V19.1C29.9986 18.11 29.1804 17.3 28.1804 17.3ZM28.1804 20.9L25.4531 27.2H17.2713V18.2L21.2168 14.294L20.2077 19.1H28.1804V20.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 18.2002H10V29.0002H13.6364V18.2002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpLiked);
export default __webpack_public_path__ + "static/media/thumb_up_liked.037cb7827e94cb87d156a3f3f09aed68.svg";
export { ForwardRef as ReactComponent };